export const joinErrors = (fieldErrors: string[] | undefined) => (fieldErrors ? fieldErrors.join(', ') : undefined)
